import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '../shared/auth-guard';
import { FeedListComponent } from './feed-list/feed-list.component';
import { ViewMembersComponent } from './view-members/view-members.component';
import { ViewGroupsComponent } from './view-groups/view-groups.component';
import { BroadcastComponent } from './compose-message/broadcast/broadcast.component';
import { AlertComponent } from './compose-message/alert/alert.component';
const routes: Routes = [
    { path: 'feed', component: FeedListComponent, canActivate: [AuthGuard] },
    { path: 'broadcast', component: BroadcastComponent, canActivate: [AuthGuard] },
    { path: 'alert', component: AlertComponent }
]
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class FeedRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/feed/feed-routing.module.ts